import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "searchKeyword_div"
  }, [_c("a-spin", {
    attrs: {
      spinning: _vm.listLoading
    }
  }, [_c("a-card", {
    staticClass: "first_class",
    attrs: {
      bordered: false
    }
  }, [_c("h1", [_vm._v(_vm._s(_vm.$t("serchKeyword.basicontent")))]), _c("div", {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c("a-form-model", {
    ref: "kwruleForm",
    attrs: {
      model: _vm.keywordObj
    }
  }, [_vm._l(_vm.keywordObj.keywordLangList, function (searchKeywordsObj, index) {
    return [searchKeywordsObj.required ? [_c("a-form-model-item", {
      key: "searchKeywords." + index + ".name",
      attrs: {
        label: searchKeywordsObj.titleName,
        prop: "keywordLangList." + index + ".name",
        rules: [{
          required: true,
          message: _vm.$t("serchKeyword.pls"),
          trigger: "blur"
        }]
      }
    }, [_c("a-input", {
      staticStyle: {
        width: "400px"
      },
      attrs: {
        placeholder: "",
        allowClear: "",
        maxLength: 100
      },
      model: {
        value: searchKeywordsObj.name,
        callback: function callback($$v) {
          _vm.$set(searchKeywordsObj, "name", $$v);
        },
        expression: "searchKeywordsObj.name"
      }
    })], 1)] : [_c("a-form-model-item", {
      key: "searchKeywords2." + index + ".name",
      attrs: {
        label: searchKeywordsObj.titleName
      }
    }, [_c("a-input", {
      staticStyle: {
        width: "400px"
      },
      attrs: {
        placeholder: "",
        allowClear: "",
        maxLength: 100
      },
      model: {
        value: searchKeywordsObj.name,
        callback: function callback($$v) {
          _vm.$set(searchKeywordsObj, "name", $$v);
        },
        expression: "searchKeywordsObj.name"
      }
    })], 1)]];
  })], 2)], 1), _c("h1", [_vm._v(_vm._s(_vm.$t("serchKeyword.keywordProduct")))]), _c("div", {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "20px"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "flex-end",
      "align-items": "center",
      "margin-bottom": "20px"
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      icon: "plus"
    },
    on: {
      click: function click($event) {
        return _vm.addProduct();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.add")) + " ")])], 1), _c("a-table", {
    attrs: {
      "row-selection": {
        onSelectAll: _vm.onSelectAll,
        onSelect: _vm.onSelect,
        onChange: _vm.onChange,
        selectedRowKeys: _vm.selectedRowKeys,
        columnWidth: 5
      },
      rowKey: "goodsNo",
      pagination: false,
      columns: _vm.columns,
      loading: _vm.isTableLoading,
      "data-source": _vm.productList
    },
    scopedSlots: _vm._u([{
      key: "productStatus",
      fn: function fn(text, record) {
        return _c("span", {}, [text == 1 ? _c("a-tag", {
          attrs: {
            color: "blue"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("serchKeyword.normal")) + " ")]) : _vm._e(), text == 0 ? _c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("serchKeyword.invalid")) + " ")]) : _vm._e()], 1);
      }
    }, {
      key: "sellPrice",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("span", [_vm._v(_vm._s(_vm.leftCurrencySymbol) + _vm._s(_vm._f("toThousandslsFilter")(text)) + _vm._s(_vm.rightCurrencySymbol))])]);
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-popconfirm", {
          attrs: {
            title: _vm.$t("publicuse.suerdelete"),
            "ok-text": _vm.$t("publicuse.determine"),
            "cancel-text": _vm.$t("publicuse.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.removeConfirm(record);
            }
          }
        }, [_c("a", {
          attrs: {
            href: "#"
          }
        }, [_vm._v(_vm._s(_vm.$t("publicuse.delete")))])])], 1);
      }
    }])
  }, [_c("span", {
    attrs: {
      slot: "goodsnametitle"
    },
    slot: "goodsnametitle"
  }, [_vm._v(_vm._s(_vm.$t("publicuse.goodsname")))])]), _c("div", {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c("span", {}, [_vm._v(_vm._s(_vm.$t("serchKeyword.totalProduct", {
    totalPro: _vm.listTotal
  })))]), _c("span", {
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t("serchKeyword.alreadySelect", {
    select: _vm.selectNumber
  })))]), _c("a-popconfirm", {
    attrs: {
      title: _vm.$t("publicuse.suerdelete"),
      "ok-text": _vm.$t("publicuse.determine"),
      "cancel-text": _vm.$t("publicuse.cancel")
    },
    on: {
      confirm: function confirm($event) {
        return _vm.removeConfirm(false);
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "danger"
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.delete")))])], 1)], 1)], 1)]), _c("footer-tool-bar", [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.saveKeyword
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.save")) + " ")])], 1), _c("importfailed", {
    attrs: {
      visible: _vm.importVisible,
      importObj: _vm.importObj
    },
    on: {
      "get-visible": _vm.getVisible
    }
  }), _c("selectProduct", {
    ref: "selectModal",
    attrs: {
      alreadySelect: _vm.alreadySelect
    },
    on: {
      confirmProduct: _vm.confirmProduct
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };